import React from "react";
import styled from "styled-components";
import { Flex } from "../../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ callback }) => (callback ? "100" : "10")};
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:300px !important;
  }
`;

const Submit = styled.p`
  color: #673AB7;
  font-weight: 600;
  font-size: 18px;
  // margin-left: 50px;
  cursor: pointer;
`

const Modal = ({ open,callBack ,dialogTitle, image, buttonText }) => (
  
  <ModalWrapper center open={open}>
    <ModalTextWrapper column>
      {image ? <div style={{width: "100%", textAlign: 'center'}}><img src={image} width="200" height="200" alt="img" /></div> : null }
      <p style={{fontSize:'14px',fontWeight:'bold',marginBottom:'20px'}} >{dialogTitle}</p>
      <Flex justifyBetween style={{ margin: 'auto' }}>
        {callBack 
          ? <Submit onClick={callBack}>OK</Submit>
          : null 
        }
      </Flex>
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
